import React from "react";
import {
  BusinessOutline,
  Medical,
  Cube,
  ArrowBackCircle,
} from "react-ionicons";
import constantURI from "./URI";
import stylesCommon from "./stylesCommon";
import _post from "./Functions/Post";
import Collecting from "./Functions/CollectingData";
import CollectingASAP from "./Functions/CollectingDataASAP";
import ASAPAuthenticate from "./Functions/ASAPAuthenticate";
import { Modal } from "react-bootstrap";
import stylesASAP from "./ASAP/stylesASAP";

export default class Modules extends React.Component {
  constructor() {
    super();
    this.state = {
      fetchBodies: [],
      fetchBodiesCopy: [],
      modules: [],
      username: "",
      password: "",
      token: "",
      user: "",
      isSupervisor: false,
      authenticate: false,
      loading: false,
      showAlert: true,
    };
  }

  async componentDidMount() {
    const storedModules = localStorage.getItem("Modules");
    const storedUsername = localStorage.getItem("Username");
    const storedPassword = localStorage.getItem("Password");
    const storedToken = localStorage.getItem("Token");
    const parsedModules = storedModules ? JSON.parse(storedModules) : [];
    const moduleIds = Array.isArray(parsedModules) ? parsedModules : [];
    const parsedUsername = storedUsername ? JSON.parse(storedUsername) : "";
    const parsedPassword = storedPassword ? JSON.parse(storedPassword) : "";
    const parsedToken = storedToken ? JSON.parse(storedToken) : "";
    await this.setState({
      modules: moduleIds,
      username: parsedUsername,
      token: parsedToken,
      password: parsedPassword,
    });
    const fetchBodies = [
      {
        id: 1,
        url: constantURI + "odooController/MedRepAuthentication",
        body: {
          params: {
            db: "smartrep",
            login: this.state.username,
            password: this.state.password,
          },
          token: this.state.token,
        },
        name: "MedRep",
      },
      {
        id: 2,
        url: constantURI + "odooController/ASAPAuthentication",
        body: {
          params: {
            db: "demoasap",
            login: this.state.username,
            password: this.state.password,
          },
          token: this.state.token,
        },
        name: "ASAP",
      },
      {
        id: 4,
        url: "",
        body: {},
        name: "WMS",
      },
      {
        id: 5,
        url: "",
        body: {},
        name: "OMS",
      },
    ];
    await this.setState({ fetchBodiesCopy: fetchBodies });
    const temp = [];
    this.state.fetchBodiesCopy.forEach((body) => {
      this.state.modules.forEach((item) => {
        if (body.id === item) {
          temp.push(body);
        }
      });
    });
    this.setState({ fetchBodies: temp });
  }

  showAlert = async () => {
    this.setState({ showAlert: true });
  };

  closeAlert = () => {
    this.setState({ showAlert: false });
  };

  oncancel = () => {
    this.props.history.push("/LandingPage");
  };

  onupdate = async () => {
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      this.setState({ loading: true });
    } else {
      this.props.history.push("/LandingPage");
    }
  };

  onClickModule = async (index) => {
    if (index === 1) {
      await Collecting();
      localStorage.setItem("Title", JSON.stringify([1, "MedRep"]));
      this.props.history.push("/LandingPageRep");
    } else if (index === 2) {
      this.setState({ showAlert: true });
    } else if (index === 4) {
      await localStorage.setItem("Title", JSON.stringify([4, "WMS"]));
      await this.props.history.push("/LandingPageWMS");
    } else if (index === 5) {
      await localStorage.setItem("Title", JSON.stringify([5, "OMS"]));
      await this.props.history.push("/LandingPageOMS");
    }
  };

  updateIsDoneReceiving = (value) => {
    this.setState({ isDoneReceiving: value });
  };

  render() {
    if (!this.state.loading) {
      return (
        <div
          className="container-fluid vh-100"
          style={stylesCommon.mainContainer}
        >
          <div className="pt-3">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.props.history.push("./")}
              color={"#00bfff"}
              height="50px"
              width="50px"
            />
          </div>
          <div className="row pt-5">
            {this.state.fetchBodies.map((item, index) => {
              if (item.id === 1) {
                return (
                  <div className="col-sm-6 p-2" key={index}>
                    <div
                      className=" btn card flex-fill text-center pt-3 Box-Shadow m-2"
                      onClick={() => this.onClickModule(item.id)}
                    >
                      <Medical
                        className="row align-items-center justify-content-center"
                        color={"#00bfff"}
                        height="150px"
                        width="150px"
                      />
                      <h4 className="card-text" style={stylesCommon.itemName}>
                        {item.name}
                      </h4>
                    </div>
                  </div>
                );
              } else if (item.id === 2) {
                return (
                  <div className="col-sm-6 p-2" key={index}>
                    <div
                      className="btn card flex-fill text-center pt-3 Box-Shadow m-2 invisible"
                      onClick={() => this.onClickModule(item.id)}
                    >
                      <BusinessOutline
                        className="row align-items-center justify-content-center"
                        color={"#00bfff"}
                        height="150px"
                        width="150px"
                      />
                      <h4 className="card-text" style={stylesCommon.itemName}>
                        {item.name}
                      </h4>
                    </div>
                  </div>
                );
              } else if (item.id === 4) {
                return (
                  <div className="col-sm-6 p-2" key={index}>
                    <div
                      className="btn card flex-fill text-center pt-3 Box-Shadow m-2"
                      onClick={() => this.onClickModule(item.id)}
                    >
                      <Cube
                        className="row align-items-center justify-content-center"
                        color={"#00bfff"}
                        height="150px"
                        width="150px"
                      />
                      <h4 className="card-text" style={stylesCommon.itemName}>
                        {item.name}
                      </h4>
                    </div>
                  </div>
                );
              } else if (item.id === 5) {
                return (
                  <div className="col-sm-6 p-2" key={index}>
                    <div
                      className="btn card flex-fill text-center pt-3 Box-Shadow m-2"
                      onClick={() => this.onClickModule(item.id)}
                    >
                      <BusinessOutline
                        className="row align-items-center justify-content-center"
                        color={"#00bfff"}
                        height="150px"
                        width="150px"
                      />
                      <h4 className="card-text" style={stylesCommon.itemName}>
                        {item.name}
                      </h4>
                    </div>
                  </div>
                );
              }
            })}
          </div>
          <div>
            {this.state.fetchBodies.map((item, index) => {
              if (item.id === 2) {
                return (
                  <Modal
                    key={index}
                    show={this.state.showAlert}
                    animation={false}
                  >
                    <Modal.Body>
                      <b>Do you want to sync the data?</b>
                    </Modal.Body>
                    <Modal.Body>
                      <div>
                        <div
                          className="savebutton btn"
                          onClick={() => this.oncancel()}
                        >
                          Continue
                        </div>
                        <div
                          className="cancelButton btn"
                          onClick={() => this.onupdate()}
                        >
                          Sync
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal>
                );
              } else {
                return null;
              }
            })}
          </div>
        </div>
      );
    } else {
      return (
        <div
          className="container-fluid vh-100 text-center"
          style={stylesCommon.mainContainer}
        >
          <CollectingASAP
            history={this.props.history}
            isDone={this.updateIsDoneReceiving}
          ></CollectingASAP>
        </div>
      );
    }
  }
}
